import React, { PropsWithChildren } from 'react';

import classNames from 'classnames';
import styles from './Menu.module.css';
// import { BaseProps } from '../../types';
interface BaseProps {
  // eslint-disable-next-line react/require-default-props
  className?: string;
  [key: string]: unknown;
}
export function MenuSectionVertical({
  className,
  ...props
}: PropsWithChildren<BaseProps>) {
  return (
    <div
      {...props}
      className={classNames(className, styles.MenuSectionVertical)}
    />
  );
}
